/* tslint:disable */
/* eslint-disable */
/**
 * Vividi Dashboard API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    IntervalPropertiesSummary,
    IntervalPropertiesSummaryFromJSON,
    IntervalPropertiesSummaryFromJSONTyped,
    IntervalPropertiesSummaryToJSON,
} from './IntervalPropertiesSummary';

/**
 * 
 * @export
 * @interface PropertySummaryResponse
 */
export interface PropertySummaryResponse {
    /**
     * 
     * @type {Array<IntervalPropertiesSummary>}
     * @memberof PropertySummaryResponse
     */
    items: Array<IntervalPropertiesSummary>;
}

export function PropertySummaryResponseFromJSON(json: any): PropertySummaryResponse {
    return PropertySummaryResponseFromJSONTyped(json, false);
}

export function PropertySummaryResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): PropertySummaryResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'items': ((json['items'] as Array<any>).map(IntervalPropertiesSummaryFromJSON)),
    };
}

export function PropertySummaryResponseToJSON(value?: PropertySummaryResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'items': ((value.items as Array<any>).map(IntervalPropertiesSummaryToJSON)),
    };
}

